export default {
    global: {
        close: 'Închide',
        save: 'Salvare',
        continue : 'Continua',
        confirmAndSend: 'Confirmați și trimiteți',
        mandatory_field: 'Acest câmp este obligatoriu',
        checkbox_mandatory : 'Această casetă de selectare este obligatorie',
        cancel: 'Anulați',
        ok: 'Bine',
        yes: 'Da',
        no: 'NU',
        post_success: 'Datele au fost trimise bine',
        code : 'COD:'
    },
    menu: {
        main_menu: 'Meniul principal',
        lmra: 'Deschide / Inchide LMRA',
        report_incident: 'Raportați un incident',
        report_near_incident: 'Raportați un incident aproape',
        risk_analysis: 'Analiza riscurilor',
        corona_analysis: 'Analiza Corona',
        scan_qr: 'Scanați TAG / QR-CODE',
        process_issue: "Raportați problema procesului",
        checklist: "Vizualizați lista de verificare",
        log_in: "Conectați-vă",
        log_out: "Deconectați-vă",
        emergency_numbers : "Numere de urgență",
        project_documentation : "Documentația proiectului"
    },
    default_lrma: {
        what_label: 'Înțeleg ce să fac?',
        how_label: 'Știu cum să o fac?',
        risk_label: 'Recunosc pericolele și riscurile?',
        control_label: 'Îl pot controla?',
        default_pbm_label: 'Am un EIP corect?',
        default_pbm_question: 'Am EPI corect? | 1',
        lmra_job_state_positive: 'Ok pentru a începe lucrul, vom revizui LMRA atunci când apar modificări',
        lmra_job_state_negative: 'Încă nu începem să lucrăm.',
    },
    static_three_state_lmra: {
        getting_data_title: "Cea mai recentă versiune este descărcată.",
        could_not_load_newest_list_title: 'Atenţie',
        could_not_load_newest_list: 'A apărut o eroare la obținerea celei mai recente liste. Va fi afișată o versiune mai veche salvată a listei, astfel încât să puteți continua. Dacă această problemă persistă, cel mai bine este să informați o persoană responsabilă.',
    },
    private_location: {
        title: 'Sunteți într-o locație privată?',
        body: 'Locațiile private sunt locații în afara locurilor legate de muncă.'
    },
    remarks: {
        remarksDialogTitle: 'Remarci?',
        remarksDialogPlaceholder: 'Tastați remarcile aici',
    },
    start_stop_screen: {
        start_work_btn: 'începe să lucrezi',
        stop_work_btn: "nu mai funcționa",
    },
    work_report: {
        title: "Raport de lucru",
        placeholder: "Introduceți aici raportul de lucru",
        skip_work_report: "Omiteți",
        buildingListTitle : "Construim formularul dvs. de raport de lucru, acest lucru nu ar trebui să dureze prea mult.",
        criticalErrorTitle: 'Eroare:',
        criticalErrorBody: 'A apărut o eroare la crearea formularului de raport de lucru! Vă rugăm să furnizați managerului codul de eroare de mai jos:',
    },
    incident_report: {
        title: "Raportați incidentul",
        placeholder: "Ce s-a întâmplat?",
    },
    oeps_report: {
        title: "Raportați incidentul aproape",
        placeholders: {
            machine: 'Care mașină?',
            who: 'Cine a fost implicat?',
            what: 'Ce s-a întâmplat?',
            how: 'Cum s-a întâmplat acest lucru / cum s-a întâmplat asta?',
            stop_card: 'Selectați Stopcard',
            location: 'Selectați locația',
            department: 'Selectați departamentul'
        },
        external_employee: 'Este un angajat extern',
        when_text_label: 'Când s-a întâmplat acest lucru?',
        change_date_time_btn: 'Schimbați data / ora'
    },
    risk_analysis: {
        title: {
            risk_default: "Analiza riscurilor",
            risk_default_sub_title: '',
            corona: "Analiza coroanei",
            corona_sub_title: 'Indicați condițiile de lucru de mai jos și aflați cum să lucrați în siguranță.'
        },
        lists: {
            risk_default: {
                gravity: {
                    label: 'Gravitatie',
                    gravity_01: 'minor, vătămare fără absenteism',
                    gravity_02: 'important, vătămare și absenteism',
                    gravity_07: 'invaliditate severă, permanentă / afecțiuni cronice cu incapacitate (parțială) de muncă',
                    gravity_15: 'foarte grav, 1 mort (acut pe termen lung)',
                    gravity_40: 'dezastru, decese multiple'
                },
                probability: {
                    label: 'Probabilitate',
                    probability_0_1: 'aproape imposibil de imaginat',
                    probability_0_2: 'practic imposibil',
                    probability_0_5: 'imaginabil, dar puțin probabil',
                    probability_01: 'improbabil, caz limită',
                    probability_03: 'neobișnuit, dar posibil',
                    probability_06: 'destul de posibil',
                    probability_10: 'așteptat'
                },
                exposure: {
                    label: 'Expunere',
                    exposure_0_5: 'foarte rar (1x pe an)',
                    exposure_01: 'rar (anual)',
                    exposure_02: 'uneori (lunar)',
                    exposure_03: 'ocazional (săptămânal)',
                    exposure_06: 'în mod regulat (zilnic)',
                    exposure_10: 'constant',
                },
            },
            corona: {
                distance: {
                    label: 'Distanța preconizată între mine și ceilalți:',
                    distance_01: 'D > 8 m',
                    distance_02: '6 m < D < 8 m',
                    distance_07: '2 m < D < 6 m',
                    distance_15: '1,5 m < D < 2 m',
                    distance_40: '1 m < D < 1,5 m',
                    distance_100: 'D < 1 m'
                },
                probability: {
                    label: 'Observ că alții ...',
                    probability_0_1: 'purtați o mască FFP2 + ochelari + îmbrăcăminte de protecție',
                    probability_0_2: 'purtați o mască FFP2 + ochelari',
                    probability_0_5: 'purtați o mască sau un scut facial',
                    probability_01: 'respectați cu siguranță Orientările Corona',
                    probability_03: 'poate respectați liniile directoare Corona',
                    probability_06: 'încalcă unele linii directoare Corona',
                    probability_10: 'Încălcarea liniilor directoare Corona multiple'
                },
                exposure: {
                    label: 'Șansa unui contact mai apropiat decât era de așteptat:',
                    exposure_0_5: 'Foarte puțin probabil',
                    exposure_01: 'Când mai multe lucruri merg prost',
                    exposure_02: 'Neobișnuit, dacă anumite lucruri merg prost',
                    exposure_03: 'Posibil, șansele să nu fie atât de mari',
                    exposure_06: 'Șansă destul de posibilă, rezonabilă',
                    exposure_10: 'De așteptat, aproape sigur',
                },
            },
        },
        results: {
            risk_default: {
                kinneyCode1: 'none',
                kinneyCode2: 'atenție necesară',
                kinneyCode3: 'măsurile necesare pot fi planificate',
                kinneyCode4: 'îmbunătățire imediată',
                kinneyCode5: 'nu mai funcționa'
            },
            corona: {
                kinneyCode1: 'Risc acceptabil: nu sunt necesare măsuri de protecție suplimentare',
                kinneyCode2: 'Risc posibil: necesită atenție',
                kinneyCode3: 'Risc major: Luați măsuri de protecție',
                kinneyCode4: 'Risc ridicat: Luați măsuri de protecție sporite',
                kinneyCode5: 'Risc foarte mare: Încercați să reglați activitatea, dacă este imposibil, apoi luați măsuri de protecție maxime'
            },
        },
        supportive_texts: {
            risk_default: {
                supportiveText1: '',
                supportiveText2: '',
                supportiveText3: '',
                supportiveText4: '',
                supportiveText5: ''
            },
            corona: {
                supportiveText1: 'Cunosc și respect Ghidurile Corona care se aplică în mediul meu de lucru.',
                supportiveText2: 'Cunosc și respect regulile Corona care se aplică. Cer în mod expres persoanelor din mediul meu de lucru să respecte și liniile directoare Corona. Nu sunt necesare alte măsuri de protecție suplimentare.',
                supportiveText3: 'Am fost sau am dezinfectat mâinile la începutul și la sfârșitul activității. Port un scut facial sau o mască de gură adecvată în combinație cu ochelari (de siguranță). Persoanele din mediul meu de lucru trebuie să poarte cel puțin un scut facial sau o mască pentru nas (de preferință împreună cu ochelari de protecție). Știu cum să folosesc corect aceste echipamente de protecție colectivă și să le aplic în practică. Cunosc și respect Ghidurile Corona care se aplică și cer în mod expres persoanelor din mediul meu de lucru să respecte și Ghidurile Corona. ',
                supportiveText4: 'Am fost sau am dezinfectat mâinile la începutul și la sfârșitul activității și după orice atingere nesigură. Port o mască de protecție a gurii (preferabil o mască de protecție respiratorie FFP2) în combinație cu un scut facial sau ochelari de protecție. Știu cum să folosesc corect aceste echipamente de protecție individuală (EIP) și să le aplic în practică. Cunosc orientările Corona care se aplică în mediul de lucru și, desigur, continuă să respecte aceste recomandări Corona. Cer oamenilor din mediul meu de lucru să ia, de asemenea, măsurile de siguranță necesare și să respecte orientările Corona. ',
                supportiveText5: 'Mai întâi consider dacă activitatea poate fi desfășurată într-un alt mod fără contact direct cu alte persoane. Dacă acest lucru nu este posibil, voi lua toate măsurile de siguranță posibile. Am fost sau am dezinfectat mâinile la începutul și la sfârșitul activității. Port mănuși de protecție. Port o mască de protecție respiratorie (cel puțin FFP2) în combinație cu un scut facial sau ochelari de protecție și îmbrăcăminte de protecție. Știu cum să folosesc corect aceste echipamente de protecție individuală (EIP) și să le aplic în practică. Cunosc orientările Corona care se aplică în mediul de lucru și, desigur, continuă să respecte aceste recomandări Corona .. Le cer oamenilor din mediul meu de lucru să ia, de asemenea, măsurile de siguranță necesare și să respecte îndrumările Corona cu atenție. '
            }
        },
        leave_warning: {
            risk_default: {
                title: 'Atenţie',
                body: 'Sunteți pe cale să închideți această fereastră fără a trimite raportul actual de analiză a riscurilor. Sigur doriți să părăsiți pagina?'
            },
            corona: {
                title: 'Atenţie',
                body: 'Sunteți pe cale să închideți această fereastră fără să trimiteți raportul actual de analiză Corona. Sigur doriți să părăsiți pagina?'
            }
        },
        report_title: 'Raport de analiză',
        placeholder_report: 'Descrieți / clarificați situația'
    },
    process_issue: {
        title: "Raportați o problemă de proces",
        placeholders: {
            issue_type_select: 'Selectați tipul de problemă',
            failure_detail: 'Selectați detaliile problemei',
            who: 'Cine a fost implicat?',
            description: 'Descrieți problema',
            cnf: 'CNF?',
            comment: 'Observații / comentarii suplimentare',
            other: 'Altele'
        }
    },
    checklist: {
        getting_data_title: "Cea mai recentă listă de verificare este colectată."
    },
    data_transfer: {
        post_busy: 'Vă rugăm să așteptați, datele sunt trimise.',
        post_success: 'Datele au fost trimise bine.'
    },
    gdpr_disclaimer: {
        title: 'Propunere GDPR:',
        body: 'Trimiterea unui articol din prima aplicație lmra, următoarele elemente vor fi stocate în baza de date: locația curentă (GPS - coordonate (după confirmare)) și ora exactă (și numai la acel moment). Niciunul dintre aceste articole nu va fi vândut altor părți, organizații. Datele stocate vor fi utilizate numai în ordinea proiectului și a condițiilor de muncă aferente ',
        accept_btn: 'Accept',
        decline_btn: 'Părăsește aplicația'
    },
    data_notice: {
        button_text: 'Ce se întâmplă cu aceste informații?',
        popup_title: '',
        popup_body: ''
    },
    cap_settings: {
        alert_cn_pid_nf_title: 'Hopa se pare că ai uitat ceva:',
        alert_cn_pid_nf_body: 'Numele clientului și / sau ID-ul proiectului nu sunt completate, vă rugăm să verificați valorile',
        client_select_placeholder: 'Selectați un client',
        project_select_placeholder: 'Selectați un proiect',
        client_not_in_list_label : 'clientul nu este în listă',
        project_not_in_list_label : 'proiectul nu este în listă',
        client_name: 'Numele clientului',
        project_id: 'ID-ul proiectului',
        project_distance: 'Distanța proiectului',
        project_shift: 'Schimbarea proiectului',
        user_initials: 'Inițialele tale',
        project_tag_code_label: 'Codul TAG al proiectului',
        warning: {
            intro: 'Acum folosiți introducerea manuală pentru',
            reason_server: 'deoarece datele serverului nu au putut fi încărcate!',
            reason_client_not_listed: 'deoarece clientul nu se afla în lista curentă!',
            reason_project_not_listed: 'deoarece proiectul nu era în lista curentă!',
            dbl_check: 'Verificați de două ori toate valorile înainte de a salva!',
            admin_msg: 'Dacă acest mesaj continuă să apară, contactați administratorul și raportați acest lucru!'
        },
        input_errors: {
            no_client_selected: 'Vă rugăm să selectați un client',
            no_project_selected: 'Vă rugăm să selectați un proiect',
        },
        loading_cap: 'Se încarcă date de pe server',
        custom_shifts_labels: {
            open_field : 'Câmp deschis'
        },
        rrqrcode:{
            scan_error_invalid_format : {
                title : "Eroare de scanare",
                body : "Format de date QR nevalid a fost detectat"
            },
            error_popup_notice_manual_mode : {
                title : "Ceva a mers prost",
                body : "Ceva a mers prost la încărcarea datelor RRQRCode, trecerea la modul manual"
            }
        }
    },
    tag_code_scanner: {
        global: {
            loading_stream: 'Se încarcă fluxul camerei ...',
            default_error_button_test: 'Ieșire'
        },
        overlay_view: {
            title: 'Scanează TAG - Cod',
            info_manual: 'Aveți probleme la scanare? Folosiți introducerea manuală ',
            manual_btn: 'Activați introducerea manuală.',
            errors: {
                invalid_tag_title: 'COD TAG nevalid',
                invalid_tag_body: 'Codul pe care l-ați scanat nu este un TAG-CODE valid, scanați un TAG-CODE valid sau comutați la introducerea manuală.',
                error_btn_txt: 'Activați introducerea manuală'
            }
        }
    },
    errors: {
        checklistNotLoaded: 'A apărut o eroare la obținerea listei, încercați din nou mai târziu. ',
        EmergencyNumbersOverviewNotLoaded: 'A apărut o eroare la obținerea listei, încercați din nou mai târziu. ',
        missing_critical_resource_title: 'Eroare la încărcarea datelor:',
        missing_critical_resource: 'O aplicație lipsește o resursă. Raportați codul de mai jos administratorului. ',
        app_corrupt: 'Se pare că configurația aplicației este deteriorată. Vă rugăm să vă contactați administratorul. ',
        data_save_failed: 'Datele nu au putut fi trimise, vă rugăm să încercați din nou mai târziu ...',
        camera: {
            NotAllowedError: 'EROARE: trebuie să acordați permisiunea pentru accesul camerei',
            NotFoundError: 'EROARE: nicio cameră pe acest dispozitiv',
            NotSupportedError: 'EROARE: este necesar un context sigur (HTTPS, localhost)',
            NotReadableError: 'EROARE: Camera este deja utilizată?',
            OverconstrainedError: 'EROARE: camerele instalate nu sunt potrivite',
            StreamApiNotSupportedError: 'EROARE: API-ul Stream nu este acceptat în acest browser',
        },
        no_internet: 'Oooops ... sunteți offline, verificați conexiunea la internet!',
        input_validation: {
            char_limit: 'Este permisă maximum% n caractere'
        },
        auth0 :{
            unverified_email : {
                error: 'Eroare: adresa de e-mail nu este verificată! Verificați-vă e-mailurile!',
                info : 'Pentru a avea acces la această aplicație <b> trebuie să vă verificați adresa de e-mail </b>. <br/> <br/> Veți <b> primi un e-mail </b> în scurt timp <b > de la |SENDER| </b> <br/> <br/> <i> Pentru a vă confirma adresa de e-mail. Urmați instrucțiunile din e-mail </i>'
            }
        }
    },
    noDataText: "Datele nu sunt disponibile ...",
    defaultDynamicQuestion : '{"dynamic_questions":[{"id":null,"question":"Am EPI corect??","correct_answer":"1"}]}',
    auth : {
        emailLabel: "E-mail",
        passwordLabel : "Parolă",
        rememberMeLabel : "Ține minte de mine",
        logInBtn: "Conectați-vă",
        logOutBtn: "Deconectați-vă",
        verifyMFABtn : "Verifică",
        errorPopupTitle: "Eroare",
        confirmIdentify : "Totuși tu?",
        errors :{
            required : "obligatoriu",
            invalidEmail : "E-mail nevalid",
            unknownError: "A apărut o eroare necunoscută"
        },
        registerNewAccountBtn : "Creează un cont nou.",
        forgotPassword : "Am uitat parola"
    },
    lmraComponent : {
        loadingProjectData : "Pregătirea formularului LMRA, vă rugăm să așteptați",
        startWorkQrDialog:{
            title: "Selectați metoda de pornire:",
            body : "Dacă aveți un cod QR Risk-reflex prezent, vă rugăm să selectați QR-Code altfel utilizați metoda de introducere manuală",
            positive_btn : "Cod QR",
            negative_btn : "Metoda manuală"
        },
        errors : {
            unknownError : "A apărut o eroare necunoscută",
            noListDataFound : "Eroare: NU S-au GĂSIT DATE DE LISTĂ!! REVENI LA LMRA IMPLICIT",
            noDefaultListFound: "Nu este disponibilă nicio listă implicită! Folosind DEFAULT LMRA!",
        }
    },
    customLmraLists : {
        buildingListTitle : "La construirea formularului LMRA, acest lucru nu ar trebui să dureze prea mult.",
        criticalErrorTitle: "Eroare:",
        criticalErrorBody: "Ceva a mers prost la construirea formularului LMRA! Vom încărca acum LMRA implicit! vă rugăm să furnizați managerului codul de eroare de mai jos : ",
    },
    workSessions :{
        global : {
            expiredLabel : "Expirat"
        },
        resumeSessionDialog : {
            titleActiveSession : "Sesiunea activă găsită",
            titleActiveSessionExpired : "(Expirat) Sesiune activă găsită",
        },
        workSessionServiceNaDialog :{
            title : "SERVICIUL DE SESIUNE DE LUCRU NU ESTE DISPONIBIL",
            body : "Ne pare rău, nu putem stabili dacă aveți o sesiune deschisă<br/><br/>" +
                "<b>Modulul LMRA este blocat: nu puteți porni sau închide o sesiune. </b><br/> Cu toate acestea, puteți trimite rapoarte de incident (în afara sesiunii)<br/>" +
                "Veți primi o notificare când serviciul de sesiune este disponibil<br/><br/>" +
                "dacă această eroare persistă, vă rugăm să vă informați administratorul..."
        },
        lmraLocked : {
            lmraComponentLockedInfo : "Ne pare rău: <b>Modulul LMRA este blocat în prezent: nu puteți porni sau închide o sesiune. </b>"
        },
        lmraVariants : {
            errors : {
                saving_session : {
                    missing_session_data : "Răspunsul serverului nu conține date de sesiune",
                    could_not_save_session : 'Nu s-au putut salva datele sesiunii local...',
                    invalid_session_data : "Datele sesiunii nu sunt valide, datele ar putea fi corupte"
                }
            }
        }
    },
    whatsAppGroup : {
        errors : {
            unknown : "A apărut o eroare necunoscută",
            notFound : "Nu a fost găsit niciun cod de grup"
        }
    },
    emergency_numbers: {
        default_number_btn_txt : "Număr implicit de urgență",
        getting_data_title: "Obținerea celor mai recente numere"
    },
    checklist_components :{
        main_checklist_component : {
            tabs : {
                active_checklist : "Lista activă",
                other_checklists : "Alte liste"
            }
        },
        checklist_detail_component : {
            toolbar:{
                title : "Vizualizare: "
            },
            warning_message : "Vizualizați o listă de verificare care nu este lista activă curentă. Pentru a vizualiza lista activă, utilizați fila \"Lista de verificare activă\" din partea de sus"
        }
    },
    version_info : {
        update : {
            version_up_to_date : "Versiunea este actualizată",
            version_minor_update : "Versiune mai nouă disponibilă (s-ar putea să nu fie disponibilă pentru chiriașul dvs.)",
            update_required : "Avertizare! Această aplicație este învechită, aplicația ar trebui să se actualizeze automat. Dacă acest mesaj persistă, contactați administratorul."
        }
    },
    risk_reflex_qr_code_scanner : {
        overlay_view : {
            errors : {
                wrong_qr_code_type : {
                    title : "Tip de cod QR greșit",
                    body : "Acest tip de cod QR nu este acceptat aici"
                },
                wrong_tenant : {
                    title : "Chiriaș greșit",
                    body : "Acest cod QR nu poate fi folosit de compania dumneavoastră"
                },
                invalid_qr_code : {
                    title : "Cod QR nevalid",
                    body : "Acesta nu este un cod QR Risk Reflex valid și nu poate fi utilizat"
                },
                invalid_qr_data : {
                    title : "Date cod QR nevalide",
                    body : "Acest cod QR nu poate fi tradus, este posibil ca codul QR să fie corupt"
                }
            },
            title : "Scanați codul QR Risk-Reflex",
            info_manual: 'Aveți probleme la scanare? Folosiți introducerea manuală ',
            manual_btn: "Comutați în modul manual"
        }
    },
    project_documentation: {
        documentation_list : {
            getting_data_title : "Obținerea documentației proiectului de pe server.",
            no_documentation_found : "Nu am putut găsi nicio documentație pentru acest proiect.",
            errors : {
                could_not_load_documentation : "Ceva a mers prost la obținerea documentației, vă rugăm să încercați din nou mai târziu."
            }
        }
    }
}